

exports.__esModule = true;
exports.$xoUpdateCardPageComponent = undefined;

var _squid = require('squid');

require('components/xo-wallet-components/src/add-card/directive');

require('components/xo-models/src/fi/index');

require('components/xo-validation/dist/directive');

require('components/xo-ui-components/src/tooltip/directive');

require('components/xo-ui-components/src/dropdown/directive');

require('components/xo-page-components/src/value-props/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoUpdateCardPageComponent = exports.$xoUpdateCardPageComponent = _squid.$Component.extend('$xoUpdateCardPageComponent', {

    tag: 'xo-update-card-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $populate, $state, $renderContent, $locale, $CheckoutSessionModel) {
        // eslint-disable-line no-shadow

        $scope.callbacks = {
            finish: function finish() {
                $state.go('checkout.review');
            }
        };
        $scope.token = $rootScope.token;
        $scope.locale = $locale;

        var models = {};

        function setErrorMessage(contentKey) {
            $scope.message = {
                msgs: [$renderContent(contentKey)],
                type: 'info'
            };
        }

        $populate(models, {
            checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop
                }
            })
        }).then(function () {

            if (models.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD') {
                setErrorMessage('creditcard.errorUnconfirmedCard');
            } else {
                setErrorMessage('creditcard.errorExpiredCard');
            }
        });
    }
});

angular.value("$xoUpdateCardPageComponent", $xoUpdateCardPageComponent);
_squid.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-update-card/directive.js
 ** module id = 413
 ** module chunks = 1
 **/